module.exports = __webpack_public_path__ + "47a51660029fbc3dd20a9ac9b1a2856a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg50.jpeg
// module id = 62
// module chunks = 0